import React, {useContext, useEffect, ReactNode} from 'react';
import {
    TrackingContext,
    TrackingContextValue,
} from '@homeaway/react-event-tracking';
import {GENERIC_EVENT} from '../../utils/edap';

interface FilterBarV2Props {
    children?: ReactNode;
}

const FilterBarV2 = ({children}: FilterBarV2Props) => {
    const edapContext: TrackingContextValue = useContext(TrackingContext);
    useEffect(() => {
        const eventFields = {
            eventcategory: 'search',
            eventaction: 'showFilterBar',
            eventlabel: 'show filter bar',
        };
        edapContext.trigger(GENERIC_EVENT, eventFields);
    }, []);

    return <div className="Filters">{children}</div>;
};

export {FilterBarV2};
export default FilterBarV2;
